// @ts-nocheck
import Layout from "../../components/Layout"
import { Box, Button, CircularProgress, Stack } from "@mui/material"
import { useDownloadFondo, useFondo } from "../../hooks/fondi"
import { Routes, Route, useParams } from "react-router-dom"
import { Info, PlayCircleOutlineOutlined, Layers, StarSharp, UploadFile } from "@mui/icons-material"
import { PageTitle } from "../../components/PageTitle"
import { useTranslation } from "react-i18next"
import FondoDettaglio from "./FondoDettaglio"
import Supporti from "../Supporti"
import Documenti from "../Documenti"
import FilesDigitali from "../FilesDigitali"
import useUserCanWriteAndDelete from "../../hooks/permissions"
import { useIsMobile } from "../../hooks/mobile"
import filesaver from "file-saver"

export default function Fondo() {
  const { id } = useParams()
  const { t, i18n } = useTranslation()
  const { data: fondo, refetch } = useFondo(parseInt(id as string))
  const lang = i18n.language

  const { mutateAsync: download, isPending: isPendingFondi } = useDownloadFondo(parseInt(id as string))
  const isMobile = useIsMobile()
  const userCanWriteAndDelete = useUserCanWriteAndDelete()

  return (
    <Layout>
      <Stack
        sx={{
          height: "100%",
          overflow: "hidden",
        }}
      >
        <PageTitle
          padding
          border
          title={fondo?.denominazione}
          breadcrumbs={[
            {
              label: t("general.fondi"),
              iconType: StarSharp,
              to: `/${lang}/fondi`,
            },
            {
              label: fondo?.denominazione,
            },
          ]}
          tabs={[
            {
              label: t("general.dettaglio"),
              iconType: Info,
              to: `/${lang}/fondi/${id}`,
            },
            {
              label: t("general.documenti"),
              iconType: PlayCircleOutlineOutlined,
              to: `/${lang}/fondi/${id}/documenti`,
            },
            {
              label: t("general.supporti"),
              iconType: Layers,
              to: `/${lang}/fondi/${id}/supporti`,
            },
            {
              label: t("general.files"),
              iconType: UploadFile,
              to: `/${lang}/fondi/${id}/files`,
            },
          ]}
          rightBlock={
            userCanWriteAndDelete && (
              <Button
                sx={{
                  marginRight: 1,
                }}
                variant="contained"
                disabled={isPendingFondi}
                color="secondary"
                onClick={() => {
                  download().then((blob) => {
                    filesaver.saveAs(blob, `fondo_${fondo?.denominazione}.xlsx`)
                  })
                }}
              >
                {isPendingFondi ? <CircularProgress size={16} color="inherit" sx={{ mr: 1 }} /> : null}
                {t("fondo.download_excel")}
              </Button>
            )
          }
        />

        <Routes>
          <Route index element={<FondoDettaglio />}></Route>
          <Route path={`supporti`} element={<Supporti fondoId={id} />}></Route>
          <Route path={`documenti`} element={<Documenti fondoId={id} />}></Route>
          <Route path={`files`} element={<FilesDigitali fondoId={id} />}></Route>
        </Routes>
      </Stack>
    </Layout>
  )
}
